import ConfirmModal from 'components/ConfirmModal';
import React from 'react';
import { useSelector } from 'react-redux';
import { getMaxLengthTranslation, getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import style from './ConfirmDeleteModal.module.scss';


const ConfirmDeleteModal = ({
  show,
  handleDelete,
  setShow,
  customTitle,
  customDescription,
  customConfirmText,
  customCancelText,
  maxCharsPerLine = 25,
}) => {
  const translations = useSelector(state => state.translations);

  const confirmTitle =
    customTitle ??
    getMaxLengthTranslation(
      'MDP_MetodosDePago_ModalEliminarMDP_Titulo_Texto',
      translations,
      74,
    );

  const descriptionTitle =
    customDescription ??
    getMaxLengthTranslation(
      'MDP_MetodosDePago_ModalEliminarMDP_Parrafo_Texto',
      translations,
      74,
    );

  const confirmDeleteBtn =
    customConfirmText ??
    getTranslationEmptyOrNullKey('MDP_Boton_Texto_Eliminar', translations);

  const cancelBtn =
    customCancelText ??
    getTranslationEmptyOrNullKey('MDP_Boton_Texto_Cancelar', translations);

  return (
    <ConfirmModal
      open={show}
      title={confirmTitle}
      description={descriptionTitle}
      confirmText={confirmDeleteBtn}
      cancelText={cancelBtn}
      onConfirm={() => {
        handleDelete();
      }}
      onCancel={() => setShow(false)}
      cssStyle={style}
      maxCharsPerLine={maxCharsPerLine}
    />
  );
};

export default ConfirmDeleteModal;
